import { jsx } from 'react/jsx-runtime';
import { useState, useEffect } from 'react';
import { SurveyCard } from '@brandclub/bc-widgets';
import StoreCarousel from '../StoreCarousel.js';

const SurveyCarousel = ({ surveys, isLoading = false, onSurveyClick, }) => {
    // Determine mobile view based on viewport width
    const [isMobileView, setIsMobileView] = useState(() => {
        if (typeof window === 'undefined')
            return false;
        return window.innerWidth < 500;
    });
    useEffect(() => {
        const handleResize = () => {
            setIsMobileView(window.innerWidth < 500);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);
    // Card width based on viewport
    const cardWidth = isMobileView ? 240 : 280;
    // Show loading skeletons if loading and no surveys
    if (isLoading && surveys.length === 0) {
        return (jsx("div", Object.assign({ className: "tw:w-full tw:my-4" }, { children: jsx(StoreCarousel, { children: [1, 2, 3].map((i) => (jsx("div", { style: {
                        width: cardWidth,
                        height: 280,
                        borderRadius: 16,
                        backgroundColor: '#f3f4f6',
                        animation: 'pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite',
                    } }, i))) }) })));
    }
    // Don't render if no surveys
    if (!surveys || surveys.length === 0) {
        return null;
    }
    return (jsx("div", Object.assign({ className: "tw:w-full tw:my-4", style: { padding: '8px 0' } }, { children: jsx(StoreCarousel, Object.assign({ gap: 16 }, { children: surveys.map((survey) => (jsx("div", Object.assign({ style: { padding: '4px' } }, { children: jsx(SurveyCard, { survey: {
                        campaignId: survey.campaignId,
                        title: survey.title,
                        brandName: survey.brandName,
                        brandId: survey.brandId,
                        brandLogoUrl: survey.brandLogoUrl,
                        description: survey.description,
                        rewardAmount: survey.rewardAmount,
                        previewImageUrl: survey.previewImageUrl,
                    }, width: cardWidth, onClick: onSurveyClick ? () => onSurveyClick(survey) : undefined }) }), survey.campaignId))) })) })));
};

export { SurveyCarousel, SurveyCarousel as default };
//# sourceMappingURL=SurveyCarousel.js.map
